var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action",attrs:{"disabled":_vm.disabled,"data-qa":"action"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",[_vm._t("prefix"),_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("postfix")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }